module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_ce5966dc.01ec9266.woff2";